import SSRIcon from "@ingka/ssr-icon";
import similarImagesIcon from "@ingka/ssr-icon/paths/image-stack";
import Text from "@ingka/text";

type Props = {
  filename: string;
  onShowSimilarImagesClicked: (filename: string) => void;
};

export function ShowSimilarImages({
  filename,
  onShowSimilarImagesClicked,
}: Props) {
  return (
    <div
      // TODO: This is forbidden as per a11y, only interactive elements should have onClickHandlers
      className="group flex cursor-pointer items-center justify-between gap-x-space50"
      onClick={() => onShowSimilarImagesClicked(filename)}
    >
      <Text bodySize="s" className="underline group-hover:text-blue-500">
        Show similar images
      </Text>
      <div className="relative">
        <SSRIcon
          className="mt-space25 group-hover:text-blue-500"
          paths={similarImagesIcon}
        />
      </div>
    </div>
  );
}
